<template>
  <div class="pl-10 pr-10 py-4 flex items-center justify-between cursor-pointer"
       :class="{
         'border-0 border-b border-solid border-soft': !isLast,
         'bg-primary-light': isSelected
       }"
       @click="$emit('select-channel', channel)"
  >
    <span class="text-black flex items-center gap-2">
      <ChannelTypeIcons :selected-channels="[channel]" :has-tooltip="false"/>
      {{ channel.name }}
    </span>
  </div>
</template>

<script>
import ChannelTypeIcons from '@/components/analytics/filter/ChannelTypeIcons.vue'

export default {
  name: 'SettingsBotsListChannel',

  components: { ChannelTypeIcons },

  props: {
    channel: {
      type: Object,
      default: () => {}
    },
    isLast: {
      type: Boolean,
      default: false
    },
    selectedChannel: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['select-channel'],

  computed: {
    isSelected() {
      return this.channel.id === this.selectedChannel?.id
    }
  }
}
</script>
